<section class="line-item-modal-container">
    <!-- <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div> -->
    <div class="modal-body">
        <!-- <pr-details-form [prDetailsForm]="purchaseRequestForm" [isReadonly]="true"></pr-details-form>
        <hr> -->
        <div class="modal-body__tabs">
            <ul class="ps-0">
                <ng-container *ngFor="let tab of prTabs; let tabIndex = index">
                    <li class="text-action" [ngClass]="{
                        'active' : tab.active
                    }">
                        <a (click)="changeTab(tab)" class="cursor-pointer">{{ tab.title }}</a>
                    </li>
                </ng-container>
            </ul>
        </div>
        <div class="modal-body__content">
            <div class="card mt-1">
                <div class="card-body p-4">
                    <div class="d-flex mb-4 mt-1 justify-content-between">
                        <ng-container *ngIf="activeTab">
                            <app-tab-content (eventOutput)="onTabDataUpdate($event)"></app-tab-content>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <a class="btn btn-outline-primary mx-2" (click)="onModalClose()">Cancel</a>
        <button *ngIf="(!withRC && (lineItemDetail?.line_item_status !== 'APPROVED' || selectedAction == 'view')) || prUpdate" class="btn btn-primary mx-2 text-white" [disabled]="selectedAction == 'view'|| !isFormValid() || !isBalanceValid" (click)="saveDetails()">Save Details</button>
        <button *ngIf="withRC" class="btn btn-primary mx-2 text-white" [disabled]="!_prTabList[0].componentInput.rcLineItems?.length" (click)="saveDetails()">Add</button>
    </div>
</section>